import { Component,ElementRef, Renderer2,ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

declare let gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent  {

  @ViewChild('mySidebar') sidebar:ElementRef;
  @ViewChild('main') main:ElementRef;

  sidebarWidth : any= "50px";
  mainContentWidth : any ="50px";
  sideNavStatus: boolean =false;

  relNumber: any = [];
  releaseNo: string;
  releaseNoStart: number;
  releaseNoEnd: number; 
  inputInfo : any =[];



  constructor(public router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'UA-198597215-1',
          {
            'page_path': event.urlAfterRedirects,
            'send' :'pageview'
          }
        );
      }
    }
    )
  }

  public onRouterOutletActivate(event : any) {
    console.log('...',event.constructor.name);
    this.inputInfo.push({'componant':event.constructor.name});
  
}

}